import { FileDataTypeEnum } from "@/lib/rana-file-data-type";

export const getDataTypeFromFile = (file: {
  dataType?: string | null | undefined;
  id: string;
}): FileDataTypeEnum => {
  const dataType = file.dataType;
  if (!dataType) {
    throw new Error(`File ${file.id} does not have a dataType`);
  }

  if (!Object.values(FileDataTypeEnum).includes(dataType as FileDataTypeEnum)) {
    throw new Error(`File ${file.id} has an unknown dataType: ${dataType}`);
  }
  return dataType as FileDataTypeEnum;
};
